/**
 * 页面title相关
 */
import useragent from '@common/useragent'
import { absUrl } from '@common/host'

/**
 * 设置页面的title
 * title{String,Array}:需要设置的title
 * 说明：设置页面的title
 */
export const set = (title) => {
  if (title && title.length > 0) {
    document.title = title
    if (useragent.isIOS) {
      const iframe = document.createElement('iframe')
      if (!useragent.isSuishouji) {
        iframe.setAttribute('src', absUrl('/public-vue/placeholder.png'))
      }
      iframe.style.display = 'none'
      iframe.addEventListener('load', () => {
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 0)
      })
      document.body.appendChild(iframe)
    }
  }
}

export default {
  set
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/title.js